import { Landlord } from "js/components/types";

import { AxiosInstance } from "../utils/AxiosInstance";

interface PaginationParams {
  current?: number;
  pageSize?: number;
}

export const getLandlords = async ({
  current = 1,
  pageSize = 15,
}: PaginationParams = {}) => {
  const { data } = await AxiosInstance.get(`/v1/tenants/landlords`, {
    params: {
      limit: pageSize,
      offset: (current - 1) * pageSize,
    },
  });
  return data;
};

export const createLandlord = async (newLandlord: Landlord) => {
  const { data } = await AxiosInstance.post(
    `/v1/tenants/landlords/`,
    newLandlord,
  );
  return data;
};

export const updateLandlord = async (
  beforeUpdateLandlord: Landlord,
  landlordId: string,
  queryParams?: object,
) => {
  const { data } = await AxiosInstance.put(
    `/v1/tenants/landlords/${landlordId}`,
    beforeUpdateLandlord,
    {
      params: queryParams,
    },
  );

  return data;
};

export const deleteLandlord = async (landlordId: string) => {
  const { data } = await AxiosInstance.patch(
    `/v1/tenants/landlords/${landlordId}/disable`,
  );
  return data;
};
